import type { RefObject } from 'react';
import type { StoryElement } from '../types';
import { IconList } from './ListPicker';
import { StoryBookmarkButton } from './StoryBookmarkButton';
import { StoryPermalinkButton } from './StoryPermalinkButton';

interface StoryRowActionsProps {
  story: StoryElement;
  isAdmin?: boolean;
  listButtonRef: RefObject<HTMLButtonElement | null>;
  listPickerOpen: boolean;
  onToggleListPicker: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onStoryUpdate?: () => void;
}

/**
 * Own the story-row action visibility policy.
 *
 * Copying a Kingfisher permalink is a reader action. Bookmark and list
 * mutation are admin-mode actions. Keeping those decisions here prevents a
 * parent layout gate from accidentally hiding the reader's copy control.
 */
export function StoryRowActions({
  story,
  isAdmin,
  listButtonRef,
  listPickerOpen,
  onToggleListPicker,
  onStoryUpdate,
}: StoryRowActionsProps) {
  return (
    <span className="feed-item-actions">
      <StoryPermalinkButton story={story} />
      {isAdmin && (
        <>
          <StoryBookmarkButton story={story} onStoryUpdate={onStoryUpdate} />
          <button
            ref={listButtonRef}
            className={`feed-item-action-btn${listPickerOpen ? ' active' : ''}`}
            onClick={onToggleListPicker}
            title="Add to list"
          >
            <IconList />
          </button>
        </>
      )}
    </span>
  );
}
